import { element } from 'protractor';
import { LogEntry, StorageEntry } from '././ledger-entry';
import { Component, OnInit } from '@angular/core';
import { LedgerService } from "./ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LedgerEntry } from './ledger-entry';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
declare var M: any;
@Injectable({
  providedIn: 'root'
})
export class SenseService {

  displayType = "m";
  lead = {};
  logs = {};
  userProfile;
  user;
  addingNew = true;
  backup = false;
  fullView = false;
  incomeStatement = { "container": [], "directCost": [], "directCostCr": [], "sales": [], "totalSales": 0, "exp": [], "taxes": [], "zero": [], "totalZero": 0, "expOp": [], "totalExpOp": 0, "expOpCr": [], "totalExpOpCr": 0, "totalTaxes": 0, "totalExp": 0, "totalContainer": 0, "totalDirectCost": 0, "totalDirectCostCr": 0, "totalCogs": 0 };
  ledger: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;

  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  entryToEdit: any = {};
  autoComplete = {
    supplier: {},
  };
  autoCompleteKeys = {

    supplier: {},

  };
  productsReadyForOrder = [];
  chartDataDuplicate = {};
  chartData = {
    // label: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 0
    // },
    // labelOne: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 1
    // },
    // labelTwo: {
    //   labels: ['one', 'two'],
    //   data: [
    //     { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //     { Red: 6, Blue: 10, Yellow: 5, Green: 14, Purple: 16, Orange: 2 }
    //   ],
    //   type: 2
    // },
    // labelFour: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 3
    // },
    // labelFive: {
    //   data: { Red: 12, Blue: 19, Yellow: 9, Green: 4, Purple: 16, Orange: 10 },
    //   type: 4
    // },
    // labelSix: {
    //   data: [{ x: 12, y: 19, r: 9 }, { x: 4, y: 16, r: 10 }],
    //   type: 5
    // }
  };
  chartDataString = JSON.stringify(this.chartData);
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = [];
  LedgerEntry: LedgerEntry = {
    id: "",
    TXN: "",
    supplier: "",
    shipmentNumber: 0,
    codeCredit: "",
    codeDebit: "",
    creditName: "",
    creditValue: 0,
    date: new Date(),
    debitName: "",
    debitValue: 0,
    cashFlow: 0,
    comment: "",
    user: "",
    userId: "",
    userEmail: "",
    userNumber: "",
  }

  constructor(public authService: AuthService, private db: AngularFirestore, private ledgerService: LedgerService) {
    // this.getProductsReady();
  }

  getDate(element) {
    let unix_timestamp = element.date['seconds']
    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds.
    return new Date(unix_timestamp * 1000);
  }
  get getProductsReadyForOrder() {
    
    JSON.parse(localStorage.getItem('productsReadyForOrder'))==null?null:this.productsReadyForOrder = JSON.parse(localStorage.getItem('productsReadyForOrder'));
    // this.productsReadyForOrder == null?this.getProductsReady:null
      // console.log(this.productsReadyForOrder);
      return this.productsReadyForOrder

  }
  getStock() {
    this.productsReadyForOrder = [];
    let collection = this.db.collection("generalStorage")
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as StorageEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          if (this.logs[data.supplier][data.code]) {
            this.logs[data.supplier][data.code].stock = data.quantity;
            this.logs[data.supplier][data.code].timeLeft = this.lead[data.supplier].leadTime - (data.quantity / this.logs[data.supplier][data.code].avgCons)
            this.logs[data.supplier][data.code].timeToOrder = this.lead[data.supplier].leadTime >= (data.quantity / this.logs[data.supplier][data.code].avgCons)
            // this.logs[data.supplier][data.code].timeToOrder ? this.logs[data.supplier][data.code].timeLeft = this.lead[data.supplier].leadTime - this.logs[data.supplier][data.code].timeLeft : null;
            this.logs[data.supplier][data.code].timeToOrder ? this.productsReadyForOrder.push({ avgCons: this.logs[data.supplier][data.code].avgCons, leadTime: this.lead[data.supplier].leadTime, timeLeft: this.logs[data.supplier][data.code].timeLeft, data }) : null;
          }//Use spread operator to add the id to the document data
          return { id, data };
        });
      });
  }
  getAvgCons() {
    var me = this;
    Object.keys(this.logs).forEach(function (supplier) {
      //var value = data[key];
      var that = me;
      //  console.log(me.logs)
      Object.keys(me.logs[supplier]).forEach(function (code) {
        //var value = data[key];
        let totalSale = 0;
        let period = 0;//in month
        let dates = [];
        let leadTime = that.lead[supplier].leadTime;
        let today = new Date();
        let startDate = that.subMonths(today, leadTime);
        var who = that;
        that.logs[supplier][code].logs.forEach(element => {
          if (that.getDate(element).getTime() > startDate.getTime())
            totalSale += element.sale;
          totalSale -= element.return;
          element.type == "sale" ?
            dates.push(element.date) :
            // element.type == "new" ?
            //   max = new Date(Math.min.apply(null, [max, who.getDate(element)])) :
            null;
          // console.log(Math.min.apply(null, [max, who.getDate(element)]), who.getDate(element));
        });// max date? 
        // var maxDate = new Date(Math.max.apply(null, dates));
        // var minDate = new Date(Math.min.apply(null, dates));
        var maxDate = new Date();
        // var minDate = new Date(max);


        dates.length ? null : period = that.monthDiff(startDate, maxDate);
        //  console.log(supplier, code, totalSale, period, startDate, maxDate);
        period == 0 ? that.logs[supplier][code].avgCons = totalSale : that.logs[supplier][code].avgCons = totalSale / period;
      });
    });
  }
  subMonths(date, months) {
    var d = date.getDate();
    date.setMonth(date.getMonth() - months);
    return date;
  }

  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }
  getLogs() {
    let collection = this.db.collection("generalLog", ref => ref.where('type', '==', "sale"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.logs = {}
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LogEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.logs[data.supplier] ? null : this.logs[data.supplier] = {};
          this.logs[data.supplier][data.code] ? null : this.logs[data.supplier][data.code] = { logs: [], avgCons: 0, code: data.code, name: data.name, totalSale: 0, totalRetailSale: 0, totalGrossSale: 0 };
          this.logs[data.supplier][data.code].totalSale += data.sale;
          this.logs[data.supplier][data.code].totalRetailSale += (data.sale * data.retailPrice);
          this.logs[data.supplier][data.code].totalGrossSale += (data.sale * (data.retailPrice - data.actualCost));
          this.logs[data.supplier][data.code].logs.push(data);
          this.logs[data.supplier][data.code].logs.sort(function (a, b) { return a.date - b.date });//? check sort is desc?
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    //  console.log(this.logs);

    collection = this.db.collection("generalLog", ref => ref.where('type', '==', "new"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LogEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.logs[data.supplier] ? null : this.logs[data.supplier] = {};
          this.logs[data.supplier][data.code] ? null : this.logs[data.supplier][data.code] = { logs: [], avgCons: 0, code: data.code, name: data.name, totalSale: 0, totalRetailSale: 0, totalGrossSale: 0 };
          this.logs[data.supplier][data.code].logs.push(data);
          this.logs[data.supplier][data.code].logs.sort(function (a, b) { return a.date - b.date });//? check sort is desc?
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    collection = this.db.collection("generalLog", ref => ref.where('type', '==', "return"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LogEntry;
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.logs[data.supplier] ? null : this.logs[data.supplier] = {};
          this.logs[data.supplier][data.code] ? null : this.logs[data.supplier][data.code] = { logs: [], avgCons: 0, code: data.code, name: data.name, totalSale: 0, totalRetailSale: 0, totalGrossSale: 0 };
          this.logs[data.supplier][data.code].totalSale -= data.sale;
          this.logs[data.supplier][data.code].totalRetailSale -= (data.sale * data.retailPrice);
          this.logs[data.supplier][data.code].totalGrossSale -= (data.sale * (data.retailPrice - data.actualCost));
          this.logs[data.supplier][data.code].logs.push(data);
          this.logs[data.supplier][data.code].logs.sort(function (a, b) { return a.date - b.date });//? check sort is desc?
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    //  console.log(this.logs);

  }
  getLeadTime() {
    //let leadTime = 0;// ref => ref.where('supplier', '==', supplier)
    let collection = this.db.collection("generalSupplier")
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.lead = {};
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          //  console.log(data);
          this.lead[data.supplier] = { leadTime: data.leadTime, supplier: data.supplier };
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
  }
  getChartData() {
    this.chartDataString = JSON.stringify(this.chartData);
    setTimeout(function () {
      (<HTMLInputElement>document.getElementById("initChart")).click();
    }, 500);
  }
  getProductsReady() {
    this.productsReadyForOrder = [];
    this.getChartData();
    this.getLeadTime();
    this.getLogs();
    console.log(localStorage.getItem("productsReadyForOrder"),this.productsReadyForOrder,this.logs);


    var me = this;
    setTimeout(function () { me.getAvgCons(); }, 800);
    setTimeout(function () { me.getStock(); }, 1500);
    setTimeout(function () {
      localStorage.removeItem("productsReadyForOrder");

      localStorage.setItem("productsReadyForOrder", JSON.stringify(me.productsReadyForOrder));
      // me.productsReadyForOrder ? me.productsReadyForOrder.length ?
      //   M.toast({ html: 'There is  ' + me.productsReadyForOrder.length + ' products ready for orders!', displayLength: 6000 })
      //   : null : null
    }, 2500);
  }
}


